import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ICONS } from "../../../utils/fontawesome";

const formatDate = (value) => {
  if (!value) return "";
  const dateObj = new Date(value);
  if (Number.isNaN(dateObj.getTime())) return "";
  return dateObj.toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });
};

const variantStyles = {
  blocage: {
    container: "border border-rose-300 bg-rose-50",
    title: "text-rose-800",
    date: "text-rose-700",
  },
  evenement: {
    container: "border border-green-300 bg-green-50",
    title: "text-green-800",
    date: "text-green-700",
  },
};

const GestionMoodItemCard = ({
  variant = "blocage",
  title,
  startDate,
  endDate,
  zoneLabel,
  atelierLabel,
  onEdit,
  onDelete,
}) => {
  const styles = variantStyles[variant] || variantStyles.blocage;
  const hasDateRange = startDate || endDate;

  return (
    <div
      className={`${styles.container} rounded-lg p-3 flex flex-col gap-2`}
    >
      <div className="flex items-center justify-between gap-2">
        <p className={`text-xs uppercase tracking-wide font-semibold ${styles.title}`}>
          {title}
        </p>
        {hasDateRange && (
          <p className={`text-xs font-medium ${styles.date}`}>
            {formatDate(startDate)}
            {endDate ? ` - ${formatDate(endDate)}` : ""}
          </p>
        )}
        <div className="flex items-center gap-1">
          <button
            type="button"
            aria-label="Éditer"
            onClick={onEdit}
            disabled={!onEdit}
            className={`px-1.5 rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-orange-200 ${
              onEdit
                ? "border-slate-200 text-slate-500 hover:text-slate-800 hover:border-slate-400"
                : "border-slate-100 text-slate-300 cursor-not-allowed"
            }`}
          >
            <FontAwesomeIcon icon={ICONS.edit} className="h-3.5 w-3.5" />
          </button>
          <button
            type="button"
            aria-label="Supprimer"
            onClick={onDelete}
            disabled={!onDelete}
            className={`px-1.5 rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-orange-200 ${
              onDelete
                ? "border-slate-200 text-slate-500 hover:text-slate-800 hover:border-slate-400"
                : "border-slate-100 text-slate-300 cursor-not-allowed"
            }`}
          >
            <FontAwesomeIcon icon={ICONS.trash} className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>

      {zoneLabel && (
        <div className="text-sm text-slate-800">
          <span className="font-semibold">Zone :</span> {zoneLabel}
        </div>
      )}
      {atelierLabel && (
        <div className="text-sm text-slate-800">
          <span className="font-semibold">Atelier :</span> {atelierLabel}
        </div>
      )}
    </div>
  );
};

export default GestionMoodItemCard;
